import React from "react";
import Logo from "../Logo";
import { Controller } from "../LastCalled";
import CurrentDateTime from "../CurrentDateTime";
import { ValueService } from "@dqm/value-observer";

export interface Props {
  valueService: ValueService;
}

const TopBar: React.FC<Props> = ({ valueService }) => {
  return (
    <div className="dqm-tcui-top_bar">
      <Logo />
      <Controller valueService={valueService} />
      <CurrentDateTime />
    </div>
  );
};

export default TopBar;
